import { UpdateControleMateriaisRequest } from "../../../data/daos/update/update_controle_materiais";
import { IUpdateControleMateriaisUseCase } from "../../../presentation/useCases/update/update_controle_materiais_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * UpdateControleMateriaisUseCase
 */

export class UpdateControleMateriaisUseCase implements IUpdateControleMateriaisUseCase {
  constructor(private readonly repository: IObrasRepository) {}

  async updateControleMateriais(modal: UpdateControleMateriaisRequest): Promise<void> {
    const response = await this.repository.updateControleMateriais(modal);
    return response;
  }
}
